import { BankMatchObjectSource, BankMatchObjectSourceValue } from '../enums'

const toTypeToken = (value: string): string => {
  const withoutId = value.includes(':') ? value.split(':')[0] : value
  const segments = withoutId.split('\\')

  return segments[segments.length - 1] ?? withoutId
}

const toObjectSource = (type: string): BankMatchObjectSourceValue => {
  const token = toTypeToken(type)

  if (token === 'bill' || token === 'Bill' || token === 'AbstractBill') {
    return BankMatchObjectSource.Bill
  }

  if (
    token === 'invoice' ||
    token === 'Invoice' ||
    token === 'externalInvoice' ||
    token === 'ExternalInvoice' ||
    token === 'AbstractInvoice' ||
    token === 'creditNote' ||
    token === 'CreditNote'
  ) {
    return BankMatchObjectSource.Invoice
  }

  return BankMatchObjectSource.LedgerEntry
}

export const getBankMatchObjectSource = (
  types: Array<string | undefined | null>,
): BankMatchObjectSourceValue | undefined => {
  const subjectTypes = types.filter((type): type is string => Boolean(type))

  if (subjectTypes.length === 0) {
    return undefined
  }

  if (subjectTypes.length > 1) {
    return BankMatchObjectSource.MultiObjects
  }

  return toObjectSource(subjectTypes[0])
}
